<template>
  <v-container grid-list-xl fluid text-xs-center>
    <v-layout row wrap>
      <v-flex lg2>
        <v-card class="display-1 pa-5 blue-grey white--text">123</v-card>
      </v-flex>
      <v-flex lg2>
        <v-card class="display-1 pa-5 green white--text">234</v-card>
      </v-flex>
      <v-flex lg2>
        <v-card class="display-1 pa-5 green white--text">234</v-card>
      </v-flex>
      <v-flex lg2>
        <v-card class="display-1 pa-5 green white--text">234</v-card>
      </v-flex>
      <v-flex lg2>
        <v-card class="display-1 pa-5 green white--text">234</v-card>
      </v-flex>
      <v-flex lg2>
        <v-card class="display-1 pa-5 green white--text">234</v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BaseWidget from '../base-widget';
import DialogFilterConfig from '../dialog-filter';

export default {
  name: "Glance",
  extends: BaseWidget,
  props: ['range']
}
</script>

<style scoped>

</style>
